
    <!--
 * 电脑端-pc微端下载
 * @LastEditTime: Thu Sep 19 2024 16:44:01 GMT+0800 (中国标准时间)
 -->
 <template>
  <a id="u_c_UBW523" target="_blank" data-gtm="gtm-download-pc" :href="downloadLink" :style="`animation:${ compData.btnAnimation }`" :class="[`normal`,`u_c_UBW523`]" @click="u_c_UBW523_event_UI3524($event)"></a>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"href":`https://gevents.37games.com/exe/dzgkr/dzgkr_install_1.0.0.exe`,"btnAnimation":`btn-breathe 2s ease-in-out infinite`},"en-US":{"href":`https://gevents.37games.com/exe/muglo/MU Dark Epoch_downloader_install.exe`,"btnAnimation":`btn-breathe 2s ease-in-out infinite`}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();

    // 自定义setup - 开始
    const zzyPoint = inject("zzyPoint", () => {});
const gaClickUpload = inject("gaClickUpload", () => {});
let urlCid = utils.getUrlParams("cid");
let urlScid = utils.getUrlParams("scid");
let urlgclid = utils.getUrlParams("gclid");
let urladid= utils.getUrlParams("adid");
let urladname= utils.getUrlParams("adname");
let urlcamid= utils.getUrlParams("camid");
let urlcamname= utils.getUrlParams("camname");
let urladsetid= utils.getUrlParams("adsetid");
let urladsetname= utils.getUrlParams("adsetname");

if (urlCid) {
  utils.setCookie("cid", urlCid, 90);
}

if (urlScid) {
  utils.setCookie("scid", urlScid, 90);
}

if (urlgclid) {
  let gclsrc = utils.getUrlParams("gclsrc");
  if (!gclsrc || gclsrc.indexOf("aw") !== -1) {
    utils.setCookie("gclid", urlgclid, 90);
  }
}

let cid = urlCid || utils.getCookie("cid");
let scid = urlScid || utils.getCookie("scid");
let gclid = urlgclid ||utils.getCookie("gclid");

const utf8_to_b64=(str)=> {
  return window.btoa(unescape(encodeURIComponent(str)));
}

const adupload = (uploadParam, md5glicd) => {
  request.getJSON(
    `//${utils.getGapi("passport")}/micro_game/add_adparams`,
    {
      key: md5glicd,
      adParams: encodeURIComponent(utf8_to_b64(uploadParam)),
    }
  );
};

const h5upload = () => {
  const ajaxHost =
    utils.getMainHost() == "gm99.com"
    ? "h5callback.gm99.com/api/v1/mtw_h5"
    : "h5callback-global.37games.com/api/v1/mglb_h5";
  request.getJSON(`//${ajaxHost}`, {
    apikey:
      utils.getMainHost() == "gm99.com"
      ? "hPZ1JP6RR74pE88jpuPdR5pK6fA9rcoD"
      : "nlXp9o2YfeBKQETB15HJQbvubmQhdNZN",
    gameID:pageData.gameId,
    event: "download",
    ext11: utils.getUrlParams("cid") || 1,
    ext12: encodeURIComponent(utils.getUrlParams("scid")),
    ext22: gclid,
    ext23: utils.getUrlParams("packageName"),
    fbc: utils.getCookie("_fbc"),
    fbp: utils.getCookie("_fbp"),
    adid: utils.getUrlParams("adid"),
    adname: utils.getUrlParams("adname"),
    camid: utils.getUrlParams("camid"),
    camname: utils.getUrlParams("camname"),
    adsetid: utils.getUrlParams("adsetid"),
    adsetname: utils.getUrlParams("adsetname")
  });
};


const downloadLink = ref(compData.href);
      // pc微端下载的click事件
      const u_c_UBW523_event_UI3524= async (e)=>{
        try {let _fbc = utils.getCookie('_fbc')
if(!_fbc){
  let fbclid = utils.getUrlParams("fbclid")
  _fbc = fbclid ? `fb.1.${new Date().getTime()}.${fbclid}` :""
};

let uploadParam = `gclid=${gclid}&cid=${cid}&scid=${scid}&fbp=${utils.getCookie(
  '_fbp'
)}&fbc=${_fbc}&adid=${urladid}&adname=${urladname}&camid=${urlcamid}&camname=${urlcamname}&adsetid=${urladsetid}&adsetname=${urladsetname}`;

let md5glicd = utils.md5(uploadParam);
downloadLink.value = compData.href.replace(/.exe$/, `_${md5glicd}.exe`);


adupload(uploadParam, md5glicd);
h5upload();
zzyPoint("gtm-download-pc");



let gtm_filter_res = utils.getCookie(`zz_gtm_filter_${pageData.gameId}_pc`);
if (!gtm_filter_res) {
  gaClickUpload("gtm-click-pc");
  if (pageData.gameId) {
    utils.setCookie(`zz_gtm_filter_${pageData.gameId}_pc`, 1, 30);
  }
}
setTimeout(() => {
  pageData.isDownloadExe = true;
}, 1000);} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_UBW523.normal{
position:absolute;
width:51.85vh;
height:8.24vh;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/08/16602717425052.png);
background-repeat:no-repeat;
background-size:contain;
background-position:center;
top:81.39vh;
left:50%;
transform:translateX(-50%);
margin-left:18.15vh;
transform-origin:0 0 !important;

}

.u_c_UBW523.normal:hover{
cursor:point;

}
}.en-US{
.u_c_UBW523.normal{
position:absolute;
width:51.85vh;
height:8.24vh;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726230410365-14.png);
background-repeat:no-repeat;
background-size:contain;
background-position:center;
top:81.39vh;
left:50%;
transform:translateX(-50%);
margin-left:18.15vh;
transform-origin:0 0 !important;

}

.u_c_UBW523.normal:hover{
cursor:point;

}
}
</style>
